module.exports = __webpack_public_path__ + "img/2015_0.65ccdccf.webp";